// extracted by mini-css-extract-plugin
export default {"secondSection":"styles_secondSection__JLLBu","carts":"styles_carts__-RnPz"};